import { Phone, MessageCircle, FileText } from "lucide-react";
import { trackEvent } from "@/lib/analytics";
import { useTr } from "@/i18n";

// Barra CTA fissa in basso — solo mobile, nascosta in admin
export default function StickyCtaBar() {
  const tr = useTr();
  const wa =
    "https://wa.me/41764411359?text=" +
    encodeURIComponent(tr("wa.message", "Ciao DJ Magix! Vorrei informazioni per un evento."));
  return (
    <nav
      data-testid="sticky-cta-bar"
      aria-label="Azioni rapide"
      className="fixed bottom-0 inset-x-0 z-[55] sm:hidden border-t border-[rgba(226,184,87,0.3)] bg-black/90 backdrop-blur-xl"
    >
      <div className="grid grid-cols-3 divide-x divide-[rgba(226,184,87,0.2)]">
        <a
          href={wa}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-cta-whatsapp"
          onClick={() => trackEvent("click_whatsapp", { source: "sticky_bar" })}
          className="flex flex-col items-center gap-1 py-2.5 text-[#25D366]"
        >
          <MessageCircle size={19} />
          <span className="text-[9px] uppercase tracking-[0.15em] font-semibold">WhatsApp</span>
        </a>
        <a
          href="tel:+41764411359"
          data-testid="sticky-cta-call"
          onClick={() => trackEvent("click_phone", { source: "sticky_bar" })}
          className="flex flex-col items-center gap-1 py-2.5 text-[#F7DE8B]"
        >
          <Phone size={19} />
          <span className="text-[9px] uppercase tracking-[0.15em] font-semibold">
            {tr("sticky.call", "Chiama")}
          </span>
        </a>
        <a
          href="#contatti"
          data-testid="sticky-cta-quote"
          onClick={() => trackEvent("cta_click", { source: "sticky_bar" })}
          className="flex flex-col items-center gap-1 py-2.5 text-[#E2B857]"
        >
          <FileText size={19} />
          <span className="text-[9px] uppercase tracking-[0.15em] font-semibold">
            {tr("sticky.quote", "Preventivo")}
          </span>
        </a>
      </div>
    </nav>
  );
}
